import { serverEnvironment } from 'env'
import { segmentAnalytics } from 'integration/segment'
import { handleAPI, API_VERSION_TWO } from './apiUtils'
import store from '../redux/store'

const releaseVersion =
  import.meta.env.REACT_APP_SEMAPHORE_GIT_TAG_NAME || import.meta.env.REACT_APP_GIT_TAG

const ID_PREFIX = { aws: 1, oci: 2, staging: 3, dev: 4, default: 4 }

// list of pages that should not be tracked (for none logged users)
export const blockPages = [
  'login',
  'forgot_password',
  'change_password',
  'onboarding',
  'print',
  'billing_details',
  'unsubscribe',
  'careers',
]

const createString = (prefix: string, id: string): string => {
  const totalLength = 5
  const combined = `${prefix}${id}`
  const numZeros: number = totalLength - combined.length
  const zeros: string = '0'.repeat(Math.max(0, numZeros))

  return `${prefix}${zeros}${id}`
}

export const generatePrefix = (id: string): string => {
  return createString(ID_PREFIX[serverEnvironment ?? 'default'], id)
}

export const mixPanelBEevent = async <T extends Record<string, unknown>>(data: {
  event_name: string
  properties?: T
}): Promise<void> => {
  try {
    const url = `/${API_VERSION_TWO}/events`
    const method = 'POST'
    await handleAPI(url, {}, method, data)
  } catch (e) {
    console.log('mixpanel error', e)
  }
}

export const mixPanelAnalytics = <T extends Record<string, unknown>>(data: {
  event_name: string
  properties?: T
}): void => {
  const { payrun, auth, organization } = store.getState()
  const orgId = auth?.employee?.organization?.id.toString() ?? ''
  const isOnboarding =
    !!organization?.organization?.metadata?.first_admin_details?.first_admin_token
  const id = auth?.employee?.id?.toString()
  const orgPrefix = createString(ID_PREFIX[serverEnvironment ?? 'default'], orgId)
  const identity = createString(ID_PREFIX[serverEnvironment ?? 'default'], id ?? '')
  const permittedEvents = import.meta.env.REACT_APP_SEGMENT_PERMITTED_EVENTS?.split(',')
  const isPermitAll = Boolean(import.meta.env.REACT_APP_SEGMENT_PERMIT_ALL)

  if (
    ['aws', 'oci', 'staging', 'dev'].includes(serverEnvironment) &&
    !isOnboarding &&
    (isPermitAll || permittedEvents?.includes(data.event_name))
  ) {
    segmentAnalytics.track(
      data.event_name,
      {
        ...data.properties,
        jisr_code_version: releaseVersion || '',
        payroll_vctivation_version: payrun?.payrun_activation_status?.setup_version || 'N/A',
        is_admin: auth?.employee?.is_super_admin || false,
        org_id: orgId && orgPrefix,
      },
      {
        userId: id && identity,
        groupId: orgId && orgPrefix,
        referrer: document?.referrer || '$direct',
        referrer_domain: document?.referrer?.split('/')[2] || '$direct',
        screen_width: window?.screen.width,
        screen_height: window?.screen.height,
      },
    )
  }
}

// Function to convert the string case to human readable case
export const humanize = (str: string): string => {
  return str
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, (m) => {
      return m.toUpperCase()
    })
}
